import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { FirmwareRequestDto } from '../dtos/firmware-request.dto';
import { FirmwareResponseDto } from '../dtos/firmware-response.dto';
import { FirmwareRequestModel } from '../models/firmware-request-model';
import { FirmwareResponseModel } from '../models/firmware-response.model';
import {
  mapFirmwareRequestModelToFirmwareRequestDto,
  mapFirmwareResponseDtoToFirmwareResponseModel,
} from '../utils/mapping/mapping.util';

export const updateFirmware = createAsyncThunk<
  FirmwareResponseModel,
  FirmwareRequestModel
>(
  'firmware/update-firmware',
  async (firmwareUpdate): Promise<FirmwareResponseModel> => {
    const mandantId = localStorageService.get(
      LocalStorageProperties.SELECTED_MANDANT
    ) as string | null;
    const { id: firmwareId, ...rest } = firmwareUpdate;

    const requestDto: FirmwareRequestDto =
      mapFirmwareRequestModelToFirmwareRequestDto(rest);

    const url = createPathParams<'firmwareId' | 'mandantId'>(
      Endpoints.FIRMWARE_BY_ID,
      {
        firmwareId,
        ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
      }
    );

    const resp: AxiosResponse<FirmwareResponseDto> = await axiosInstance.put(
      url,
      requestDto
    );

    return mapFirmwareResponseDtoToFirmwareResponseModel(resp.data);
  }
);
